import { createFilterOptions } from '@mui/material/Autocomplete';

const filter = createFilterOptions();

export default {
  filterOptions: (options, params) => {
    const filtered = filter(options, params);
    const { inputValue } = params;
    const isExisting = options.some((option) => inputValue === option.label);
    if (inputValue !== '' && !isExisting) filtered.push({ inputValue, label: `Add: "${inputValue}"` });
    return filtered;
  },
  selectOnFocus: true,
  clearOnBlur: true,
  handleHomeEndKeys: true,
  getOptionLabel: (option) => {
    if (typeof option === 'string') return option;
    if (option.inputValue) return option.inputValue;
    return option.label;
  },
  freeSolo: true
};
